module.exports = __webpack_public_path__ + "static/media/purpleIcon.099f4880.png";